import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    /* eslint-disable-next-line no-new */
    new Accordion(this.element)
  }
}
